
 <div>
    <form class="form-group" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mbsc-input 
            name="email"
            type="email"
            formControlName="email"
            [(ngModel)]="loginForm.value.email" 
            placeholder="Email"
            label="Email"
            inputStyle="outline"
            labelStyle="floating">
        </mbsc-input>
      
        <mbsc-input
          label="Passwort"
          inputStyle="outline"
          labelStyle="floating"
          [passwordToggle]="true"
          type="password" 
          formControlName="password"
          placeholder="Password">
        </mbsc-input>
      
       
        <button *ngIf="!formIsVAlid"cButton type="submit" variant="outline">Anmelden</button>
      </form>
 </div>